import { FormattedMessage } from 'react-intl';
import moment from 'moment';

import './style.scss';

interface IProps {
  dateStr?: string;
  daysUntilExpiration?: number;
  status?: string;
}

function formatDate(dateStr: string | undefined): string {
  if (!dateStr) return '—';
  const m = moment(dateStr, moment.ISO_8601, true);
  return m.isValid() ? m.format('MM/DD/YYYY') : '—';
}

export function RewardExpirationCell(props: IProps) {
  const { dateStr, daysUntilExpiration, status } = props;
  const dateFormatted = formatDate(dateStr);
  const statusLower = (status ?? '').toLowerCase();

  const daysLeft =
    daysUntilExpiration != null
      ? daysUntilExpiration
      : dateStr && moment(dateStr, moment.ISO_8601, true).isValid()
        ? moment(dateStr).diff(moment(), 'days')
        : null;

  const isExpired = daysLeft != null && daysLeft < 0;
  const isRedeemed = statusLower === 'redeemed';

  // Redeemed: date only, no secondary message
  if (isRedeemed) {
    return (
      <div className="reward-expiration-cell">
        <span className="reward-expiration-cell__date">{dateFormatted}</span>
      </div>
    );
  }

  const urgency =
    daysLeft != null && daysLeft >= 0
      ? daysLeft <= 7
        ? 'urgent'
        : daysLeft <= 30
          ? 'soon'
          : null
      : null;

  return (
    <div className="reward-expiration-cell">
      <span className="reward-expiration-cell__date">{dateFormatted}</span>
      {isExpired ? (
        <span className="reward-expiration-cell__days reward-expiration-cell__days--expired">
          <FormattedMessage id="rewards.expiration.expired" />
        </span>
      ) : (
        daysLeft != null &&
        daysLeft >= 0 && (
          <span className={`reward-expiration-cell__days ${urgency ? `reward-expiration-cell__days--${urgency}` : ''}`}>
            <FormattedMessage id="rewards.expiresInDays" values={{ days: daysLeft }} />
          </span>
        )
      )}
    </div>
  );
}
